import { render, staticRenderFns } from "./KlanttoegangsModal.vue?vue&type=template&id=1badcc94"
import script from "./KlanttoegangsModal.vue?vue&type=script&lang=js"
export * from "./KlanttoegangsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports